import React from 'react';
import './tag-chip.scss';
import { View, Text } from '../../common';
import { SVGS } from '../../assets';

type TagChipVariant = number | 'gray' | 'active' | 'inactive';

interface TagChipProps {
  tagName: string;
  needTagIcon?: boolean;
  variant?: TagChipVariant;
  containerClass?: string;
  textClass?: string;
}

export const TagChip: React.FC<TagChipProps> = ({
  tagName,
  needTagIcon = true,
  variant,
  containerClass = 'tag-chip-card default-chip',
  textClass = 'tag-chip-card-text font-regular default-text',
}) => {
  if (variant === 'gray') {
    containerClass = 'tag-chip-card bg-gray-tag';
    textClass = 'tag-chip-card-text font-regular text-gray-tag';
  } else if (variant) {
    containerClass = `tag-chip-card bg-color-${variant} border-color-${variant}`;
    textClass = `tag-chip-card-text font-regular text-color-${variant}`;
  }

  return (
    <View className={containerClass}>
      {needTagIcon && <img src={SVGS.TagIcon} alt="tag" />}
      <Text className={textClass}>{tagName}</Text>
    </View>
  );
};
